import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { addNursesRequest } from "../redux/actions";
import { addNurseByHNRequest, inviteHeadNurseRequest } from "../redux/actions/headNurse";
import { AppState } from "../redux/types";
import { ROLE } from "../utils/constants";
import FormContainer from "./FormContainer";
import UserInviteForm from "./UserInviteForm";
import { localePath } from "../i18n/config";

const NurseForm = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const user = useSelector((state: AppState) => state.user);
    const seniorHomes = useSelector((state: AppState) => state.seniorHomes.list);
    const filteredHomes = seniorHomes;

    useEffect(() => {
        if (user && !user.isAdmin && !(user.role === ROLE.HEAD_NURSE)) {
            history.push(localePath("kirjaudu"));
        }
    }, [dispatch, history, user]);

    const handleSendInvite = (data: any) => {
        if (!data?.isHeadNurse) {
            const nurseData = {
                ...data,
                isNurse: true,
            };
            if (user.role === ROLE.HEAD_NURSE) {
                dispatch(addNurseByHNRequest(nurseData, history));
            } else {
                dispatch(addNursesRequest(nurseData, history));
            }
        } else {
            const headNurseData = {
                firstName: data.firstName,
                lastName: data.lastName,
                email: data.email,
                seniorHomeIds: data.seniorHomeIds,
            };
            dispatch(inviteHeadNurseRequest(headNurseData, history));
        }
    };

    return (
        <FormContainer>
            <h1 className="user-form-header" style={{ fontSize: "2.4rem" }}>
                LISÄÄ UUSI SAIRAANHOITAJA
            </h1>
            {/* Add New Nurse */}
            <UserInviteForm onSendInvite={handleSendInvite} seniorHomes={filteredHomes} nurseFlag />
        </FormContainer>
    );
};
export default NurseForm;
